// extracted by mini-css-extract-plugin
export default {"admin_contain":"Admin_admin_contain__uW4E5","admin_main":"Admin_admin_main__99k-P","admin_wrap":"Admin_admin_wrap__IEfJ6"};